import { render, staticRenderFns } from "./datas.vue?vue&type=template&id=0e5abf1c&scoped=true"
import script from "./datas.vue?vue&type=script&lang=js"
export * from "./datas.vue?vue&type=script&lang=js"
import style0 from "./datas.vue?vue&type=style&index=0&id=0e5abf1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5abf1c",
  null
  
)

export default component.exports